// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-templates-index-js": () => import("./../../../src/templates/index.js" /* webpackChunkName: "component---src-templates-index-js" */),
  "component---src-templates-privacy-cookie-policy-js": () => import("./../../../src/templates/privacy-cookie-policy.js" /* webpackChunkName: "component---src-templates-privacy-cookie-policy-js" */),
  "component---src-templates-quote-js": () => import("./../../../src/templates/quote.js" /* webpackChunkName: "component---src-templates-quote-js" */),
  "component---src-templates-terms-conditions-js": () => import("./../../../src/templates/terms-conditions.js" /* webpackChunkName: "component---src-templates-terms-conditions-js" */)
}

